import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';

export const ExceptionAvailabilityCellValue = ({ isAvailable }: { isAvailable: string }) => {
  const { t } = useTranslation('schedule');

  if (isAvailable === 'true') {
    return (
      <Text as='span' weight='semibold' color='success'>
        {t('Available')}
      </Text>
    );
  } else {
    return (
      <Text as='span' color='light'>
        {t('Unavailable')}
      </Text>
    );
  }
};

export const ExceptionTimeCellValue = ({ startTime, endTime }: { startTime: string; endTime: string }) => {
  const { t } = useTranslation('schedule');

  return startTime === '12:00am' && endTime === '11:59pm' ? (
    <Text as='span' weight='regular'>
      {t('All day')}
    </Text>
  ) : (
    <Text as='span' weight='regular'>
      {startTime} - {endTime}
    </Text>
  );
};
